import "../css/style.scss";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export default function VideoCard({ props }) {
  const [loaded, setLoaded] = useState(0);

  useEffect(() => {
    setLoaded(false);
  }, []);

  const videoLoaded = () => {
    setTimeout(setLoaded, Math.random() * 1000, true);
  };
  return (
    <div>
      <div className="video-card">
        <div className="loading-anim" style={{ opacity: loaded ? 0 : 1 }}>
          <FontAwesomeIcon className="icon" icon={faPlus} spin />
        </div>
        <video
          style={{ opacity: loaded ? 1 : 0, top: loaded ? "0" : "100%" }}
          preload="metadata"
          controls={false}
          autoPlay
          muted
          loop
          onContextMenu={(event) => event.preventDefault()}
          onLoadedData={videoLoaded}
        >
          <source src={props.videoSrc} type="video/mp4" />
        </video>
        <div className="overlay">
          <h1 className="title">
            {props.title} <div className="description">{props.description}</div>
          </h1>

          {props.buttonText && (
            <div className="link" onClick={() => window.open(props.buttonURL, "_blank")}>
              {props.buttonText}
            </div>
          )}

          {props.messageText && <div className="msg">{props.messageText}</div>}
        </div>
      </div>
    </div>
  );
}
